import React from 'react';

export default function TitleWidget({ widget }) {
  return (
    <div style={{ display: 'grid', gap: '4px' }}>
      <div style={{ fontSize: '22px', fontWeight: 700, color: '#113a5b' }}>
        {widget.headerLabel || widget.data.headerLabel || 'Title'}
      </div>
      {(widget.subHeaderLabel || widget.data.subHeaderLabel) && (
        <div style={{ fontSize: '14px', color: '#47647f' }}>
          {widget.subHeaderLabel || widget.data.subHeaderLabel}
        </div>
      )}
    </div>
  );
}
